import React, { useState } from 'react';
import Button from '../../components/Button';
import DeltaPreview from '../../components/DeltaPreview';
import { MagneticWallItemWithAvatar } from '../MagneticWallItem';
import AnnotationIcon from './AnnotationIcon';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const ANNOTATION_PREVIEW_FRAGMENT = gql(`
  fragment AnnotationPreview_annotation on PublicAnnotationFields {
    id
    content
    link
  }
`);

interface AnnotationPreviewProps {
  annotation: DocumentType<typeof ANNOTATION_PREVIEW_FRAGMENT>;
}

const MAX_LINES_PREVIEW = 4;

const AnnotationPreview = ({ annotation }: AnnotationPreviewProps) => {
  const [isShowingMore, setIsShowingMore] = useState(false);
  const [canBeClamped, setCanBeClamped] = useState<boolean>(false);

  return (
    <MagneticWallItemWithAvatar avatar={<AnnotationIcon hasContainer />}>
      <DeltaPreview
        typography="comment"
        maxLines={MAX_LINES_PREVIEW}
        disableLineClamp={isShowingMore}
        content={annotation.content}
        onCanBeClampedChange={setCanBeClamped}
      />
      {canBeClamped && (
        <Button
          variant="link"
          size="micro"
          onClick={() => setIsShowingMore(!isShowingMore)}
        >
          {isShowingMore ? 'Show less' : 'Show more'}
        </Button>
      )}
    </MagneticWallItemWithAvatar>
  );
};

export default AnnotationPreview;
